import React, { useState } from "react";

import Loader from "@/components/Loader.jsx";
import useLicenseDocuments from "@/hooks/useLicenseDocuments.js";
import LicenseTypeCard from "@/partials/licenses/LicenseTypeCard.jsx";
import {
  LICENSE_STORAGE_NOTICE,
  isLicenseTypeMissing,
} from "@/partials/licenses/licenseUtils.js";
import { MARKETPLACE_LICENSE_TYPES } from "@/api/marketplace.js";

function LicensesSettings() {
  const [loadError, setLoadError] = useState(null);
  const {
    docsByType,
    licenseAnswers,
    licensesRequestedAt,
    loading,
    uploadingType,
    uploadError,
    upload,
  } = useLicenseDocuments({ onLoadError: setLoadError });

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
          Licenses
        </h1>
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 max-w-3xl">
          {LICENSE_STORAGE_NOTICE}
        </p>
      </div>

      {licensesRequestedAt && (
        <div className="mb-6 max-w-3xl rounded border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 p-4 text-sm text-amber-800 dark:text-amber-200">
          Saucey requested updated license documents on{" "}
          <span className="font-medium">
            {licensesRequestedAt.toLocaleDateString()}
          </span>
          . Please upload any missing or renewed documents below.
        </div>
      )}

      {/* Content */}
      <div className="bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm mb-8 p-6">
        {loading ? (
          <div className="py-8">
            <Loader />
          </div>
        ) : loadError ? (
          <div className="rounded border border-red-300 bg-red-50 dark:bg-red-900/20 p-4 text-sm text-red-700 dark:text-red-300">
            {loadError}
          </div>
        ) : (
          <div className="space-y-5 max-w-3xl">
            {MARKETPLACE_LICENSE_TYPES.map((t) => (
              <LicenseTypeCard
                key={t.type}
                licenseType={t}
                docs={docsByType[t.type]}
                uploading={uploadingType === t.type}
                onFile={(file) => upload(t.type, file)}
                missing={isLicenseTypeMissing(t, docsByType[t.type], licenseAnswers)}
              />
            ))}
            {uploadError && (
              <div className="text-sm text-red-500">{uploadError}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default LicensesSettings;
